
export interface Truck {
  id: string;
  name: string;
  type: string;
  status: 'available' | 'in-transit' | 'maintenance';
}

export interface Route {
  pickupDate: string;
  productId: Array<{ count: number; customerLoadId: string }>;
  sourceCustomerWarehouseId: string;
  sourcePredictedCity: string;
  destinationCustomerWarehouseId: string;
  destinationPredictedCity: string;
  units: number;
  currentLoadingMode: string;
  tonnage: number;
  volume: number;
  distance: number;
  deliveryDate: string;
  activity: string;
}

export interface ComputeParams {
  truckId: string;
  driverId: string;
  driverLat: number;
  driverLong: number;
  vehicleLat: number;
  vehicleLong: number;
  date: string;
  time: string;
}

export enum AppStatus {
  IDLE = 'idle',
  LOADING = 'loading',
  REQUEST_DETAILS = 'request_details',
  SUCCESS = 'success',
  ERROR = 'error'
}
